import React, { useEffect } from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import PublicLayout, { PageHero, CtaRow } from './PublicLayout';
import HomePage from './pages/HomePage';
import HowItWorksPage from './pages/HowItWorksPage';
import FeaturesPage from './pages/FeaturesPage';
import PlusPage from './pages/PlusPage';
import SafetyPage from './pages/SafetyPage';
import FaqPage from './pages/FaqPage';
import SupportPage from './pages/SupportPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';

function NotFoundPage() {
  return (
    <PageHero
      eyebrow="404"
      title="Page not found"
      subtitle="The page you're looking for doesn't exist. Head back home or enter as guest."
    >
      <div className="flex flex-col items-center gap-4">
        <CtaRow />
        <Link to="/" className="text-xs font-black uppercase tracking-widest text-gray-400 hover:text-white">
          ← Back to home
        </Link>
      </div>
    </PageHero>
  );
}

/**
 * Public marketing website. Rendered for all non-app, non-auth, non-ticket
 * routes. Deliberately self-contained: no app shell, no service-worker
 * behavior, no onboarding.
 */
export default function PublicSite() {
  const location = useLocation();

  useEffect(() => {
    try {
      window.scrollTo(0, 0);
    } catch (_) {}
  }, [location.pathname]);

  return (
    <PublicLayout key={location.pathname}>
      <Routes location={location}>
        <Route path="/" element={<HomePage />} />
        <Route path="/how-it-works" element={<HowItWorksPage />} />
        <Route path="/features" element={<FeaturesPage />} />
        <Route path="/plus" element={<PlusPage />} />
        <Route path="/safety" element={<SafetyPage />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </PublicLayout>
  );
}
